import { render, staticRenderFns } from "./PointsForm.vue?vue&type=template&id=6f277513&scoped=true&"
import script from "./PointsForm.vue?vue&type=script&lang=js&"
export * from "./PointsForm.vue?vue&type=script&lang=js&"
import style0 from "./PointsForm.vue?vue&type=style&index=0&id=6f277513&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f277513",
  null
  
)

export default component.exports